<app-window-title title="Add link"
                  [closable]="true"
                  (closed)="dialogRef.close()"></app-window-title>

<form  class="fx-col fx-gap-10"(ngSubmit)="onSubmit($event)">
  <mat-form-field color="warn"
                  appearance="outline">
    <mat-label>
      Title
    </mat-label>
    <input name="title"
           placeholder="Enter title"
           required
           type="text"
           matInput>
  </mat-form-field>

  <mat-form-field color="warn"
                  appearance="outline">
    <mat-label>
      Link
    </mat-label>
    <input name="link"
           placeholder="Enter link"
           required
           type="text"
           matInput>
  </mat-form-field>

  <button color="warn"
          type="submit"
          mat-flat-button>
    SUBMIT
  </button>
</form>
